//import logo from './logo.svg';
//import './App.css';
import React, {useEffect,useState} from 'react';
import ReactDOM from 'react-dom'
//import {Container, AppBar, Typography, Grow, Grid} from '@material-ui/core';
import { styled, createTheme, ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import MuiDrawer from '@mui/material/Drawer';
import Box from '@mui/material/Box';
import MuiAppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import List from '@mui/material/List';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import Badge from '@mui/material/Badge';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import MyLink from '@mui/material/Link';
import MenuIcon from '@mui/icons-material/Menu';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import NotificationsIcon from '@mui/icons-material/Notifications';
import Button from '@mui/material/Button';
import ChartsEmbedSDK from "@mongodb-js/charts-embed-dom";
import { pink } from '@mui/material/colors';
import { blue } from '@mui/material/colors';
import { yellow } from '@mui/material/colors';
import { red } from '@mui/material/colors';
import { green } from '@mui/material/colors';


import { mainListItems, secondaryListItems } from './listItems';
import Stack from '@mui/material/Stack';
import L from 'leaflet';
import { MapContainer, TileLayer, Marker, Popup, CircleMarker, Map, MapControl,Rectangle } from 'react-leaflet'
import icon from 'leaflet/dist/images/marker-icon.png';
import iconShadow from 'leaflet/dist/images/marker-shadow.png';
import 'leaflet/dist/leaflet.css';
import { Icon } from "leaflet";
import {getPublicProject,filterDate, filterThresholdGood,filterThresholdUnhealthy,filterThresholdModerate,filterThresholdReset} from './features/projects/projectSlice'
import Card from '@mui/material/Card'
import Moment from 'moment'
import Chip from '@mui/material/Chip';
import Modal from '@mui/material/Modal';


import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';

import UserList from './userList';
import Odors from './odorTracker';
import MapDevice from './mapDevice';
import LeafMap from './leafMap';
import Legend from './Legend';
import logo from './logos/JustAirLogo1.png'
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { TimePicker } from '@mui/x-date-pickers/TimePicker';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';

import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import { MobileDatePicker } from '@mui/x-date-pickers/MobileDatePicker';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { toast } from 'react-toastify'
import TextField from '@mui/material/TextField';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';




import {useDispatch, useSelector} from 'react-redux'
import {getDevices} from './features/devices/deviceSlice'

import {
  BrowserRouter as Router,
  Switch,
  Route,
  Link,
  useNavigate
} from "react-router-dom";

//import memories from './memories.png'
import { logout, reset } from './features/auth/authSlice'
import useStyles from './styles'

let DefaultIcon = L.icon({
    iconUrl: icon,
    shadowUrl: iconShadow
});

L.Marker.prototype.options.icon = DefaultIcon;


const theme = createTheme({
  palette: {
    primary: {
      // light: will be calculated from palette.primary.main,
      main: '#29ABE2',
      // dark: will be calculated from palette.primary.main,
      // contrastText: will be calculated to contrast with palette.primary.main
    },
    secondary: {
      light: '#0066ff',
      main: '#0044ff',
      // dark: will be calculated from palette.secondary.main,
      contrastText: '#ffcc00',
    },
    // Used by `getContrastText()` to maximize the contrast between
    // the background and the text.
    contrastThreshold: 3,
    // Used by the functions below to shift a color's luminance by approximately
    // two indexes within its tonal palette.
    // E.g., shift from Red 500 to Red 300 or Red 700.
    tonalOffset: 0.2,
  },
});


const PublicProject = () => {


 const dispatch = useDispatch();
 const navigate = useNavigate();


 const { user } = useSelector((state) => state.auth)
 const { publicProject, filteredProjectMeasurements } = useSelector((state) => state.project)

 const [dataLength, setDataLength] = useState({ })


  useEffect(() => {
    dispatch(getDevices());




  }, [navigate, dispatch,devices]);


  const { devices, isLoading, isError, message } = useSelector(
     (state) => state.device
   )

  if (publicProject.deviceProject){

    var measures = publicProject.deviceProject[0].deviceMeasures

  }
  const [valueThresholdFilter, setValueThresholdFilter] = React.useState('All');

  const [timeValue2, setTimeValue2] = React.useState(publicProject.startDate);



  const onTimeChange2 = (newValue) => {

    setTimeValue2(newValue);

    const dateConvert = Moment(newValue).toDate();


      dispatch(filterDate({date:dateConvert}))
  };




const handleChangeThreshold = (event) => {

   setValueThresholdFilter(event.target.value);

   if (event.target.value === 'Unhealthy'){
      dispatch(filterThresholdUnhealthy(50))
   } else if (event.target.value === 'Moderate'){
      dispatch(filterThresholdModerate(20))
   }else if (event.target.value === 'Good'){
        dispatch(filterThresholdGood(20))
   }else{
      dispatch(filterThresholdReset())
   }

};




function Copyright(props) {
  return (
    <Typography variant="body2" color="text.secondary" align="center" {...props}>
      {'Copyright © '}
      <MyLink color="inherit" href="https://justair.co/" target="_blank">
        JustAir Solutions
      </MyLink>{' '}
      {new Date().getFullYear()}
      {'.'}
    </Typography>
  );
}

const drawerWidth = 240;

const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== 'open',
})(({ theme, open }) => ({
  zIndex: theme.zIndex.drawer + 1,
  transition: theme.transitions.create(['width', 'margin'], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  ...(open && {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
}));

const Drawer = styled(MuiDrawer, { shouldForwardProp: (prop) => prop !== 'open' })(
  ({ theme, open }) => ({
    '& .MuiDrawer-paper': {
      position: 'relative',
      whiteSpace: 'nowrap',
      width: drawerWidth,
      transition: theme.transitions.create('width', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen,
      }),
      boxSizing: 'border-box',
      ...(!open && {
        overflowX: 'hidden',
        transition: theme.transitions.create('width', {
          easing: theme.transitions.easing.sharp,
          duration: theme.transitions.duration.leavingScreen,
        }),
        width: theme.spacing(7),
        [theme.breakpoints.up('sm')]: {
          width: theme.spacing(9),
        },
      }),
    },
  }),
);

const mdTheme = createTheme({
  palette: {
    primary: {
      // light: will be calculated from palette.primary.main,
      main: '#5A2483',
      // dark: will be calculated from palette.primary.main,
      // contrastText: will be calculated to contrast with palette.primary.main
    },
    secondary: {
      light: '#0066ff',
      main: '#0044ff',
      // dark: will be calculated from palette.secondary.main,
      contrastText: '#ffcc00',
    },
    // Used by `getContrastText()` to maximize the contrast between
    // the background and the text.
    contrastThreshold: 3,
    // Used by the functions below to shift a color's luminance by approximately
    // two indexes within its tonal palette.
    // E.g., shift from Red 500 to Red 300 or Red 700.
    tonalOffset: 0.2,
  },
});;


  const [open, setOpen] = React.useState(false);
  const [popOpen, setPopOpen] = React.useState(false);
  const [openPM, setOpenPM] = React.useState(false);
  const [popOpenPM, setPopOpenPM] = React.useState(false);
  const [openNO2, setOpenNO2] = React.useState(false);
  const [popOpenNO2, setPopOpenNO2] = React.useState(false);
  const [pollutantTip, setPollutantTip] = React.useState("");

/*
  const hopevilleElm = [
    [41.534408298379354, -73.03337261166969],
    [ 41.531408298379354, -73.03137261166969]
  ]
  const washingtonElm = [
    [41.54399951992418, -73.03376724985056],
    [ 41.54199951992418, -73.03176724985056]
  ]
*/

  const washingtonElm = [41.54399951992418, -73.03376724985056]

  const hopevilleElm =
    [41.534408298379354, -73.03337261166969]

  const dugganElm = [41.54371134000792, -73.04757406817868]





  const greenOptions = { color: 'green' }
  const blackOptions = { color: 'black' }



  const toggleDrawer = () => {
    setOpen(!open);
  };


    var colorMarker = function (p){
      var no2 = p.no2.pi
      var voc = p.voc.pi
      var pm25 = p.pm25.pi
      var pm10 = p.pm10.pi

      var max_val = 0;

          if (no2 > voc)
          {
            max_val = no2;
          } else
          {
            max_val = voc;
          }
          if (pm25 > max_val)
          {
            max_val = pm25;
          }

          if (pm10 > max_val)
          {
            max_val = pm10;
          }


      if (max_val>100.0){
        return { color: 'purple' };
      } else if (max_val>=100.0){
        return { color: 'purple' };
      }else if (max_val>=51.0){
        return { color: 'red' };
      }else if (max_val>=20.0){
        return { color: 'yellow' };
      }else{
        return { color: '#22b573' };
      }
    }


  const onLogout = () => {
    dispatch(logout())
    dispatch(reset())
    navigate('/')

  }
  const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: 'background.paper',

  boxShadow: 24,
  p: 4,
};

const getStart = (p) => {

  return Moment(p.date)

}

 const handleOpenNO2 = () => {


   setPopOpenNO2(true);

 }

 const handleOpenPM = () => {


   setPopOpenPM(true);

 }

 const handleOpen = () => {


   setPopOpen(true);

 }

 const handleClose = () => {

   setPopOpen(false);
   setPopOpenPM(false);
   setPopOpenNO2(false);


}

  return (
    <ThemeProvider theme={mdTheme}>
      <Box sx={{ display: 'flex' }}>
        <CssBaseline />
        <AppBar position="absolute" open={open}>
          <Toolbar
            sx={{
              pr: '24px', // keep right padding when drawer closed
            }}
          >

            <Typography
              component="h1"
              variant="h6"
              color="white"
              noWrap
              sx={{ flexGrow: 1 }}
            >
              R.A.C.C.E Mobile Air
            </Typography>

            {user ? (<>
            <Button color="inherit"   onClick={() => { onLogout()}}>Logout</Button></>
              ) :
              (<>
              <Button color="inherit"   onClick={() => { navigate("/login");}}>Login</Button>
              <Button color="inherit"  onClick={() => { navigate("/register");}}>Register</Button> </>)
            }


          </Toolbar>
        </AppBar>

        <Box
          component="main"
          sx={{
            backgroundColor: (theme) =>
              theme.palette.mode === 'light'
                ? theme.palette.grey[100]
                : theme.palette.grey[900],
            flexGrow: 1,
            height: '100vh',
            overflow: 'auto',
          }}
        >
          <Toolbar />



            <Container maxWidth="xl">
                  <Grid container  alignItems="center"
          justifyContent="center" spacing={2}  >
          <Grid item xs={6} sx={{ height:1 }}>
                <Card sx={{ height:1, bgcolor:'#DED3E6' }}>
                   <CardContent sx={{ height:'200px' }}>
                     <Typography variant="h6" component="div" gutterBottom>
                      Project Name: {publicProject.projectName && publicProject.projectName}
                     </Typography>
                     <Typography variant="h6" component="div" gutterBottom>
                     Organization: {publicProject.orgName && publicProject.orgName}
                     </Typography>
                     <Typography variant="h6" component="div" >
                      Project Description:
                     </Typography>
                     <Typography variant="p" component="div" color="text.secondary">
                   {publicProject.projectDescription && publicProject.projectDescription}
                     </Typography>

                   </CardContent>

                 </Card>
            </Grid>
            <Grid item xs={5} sx={{ height:1 }}>
                    <Card sx={{ height:1, bgcolor: '#DED3E6' }}>
                       <CardContent sx={{ height:'200px' }}>
                         <Typography variant="h6" component="div" gutterBottom>
                          Project Date: {publicProject.startDate && Moment(publicProject.startDate).format('MM/DD/YYYY')} - {publicProject.endDate && Moment(publicProject.endDate).format('MM/DD/YYYY')}
                         </Typography>
                         <Typography variant="h6" component="div"  gutterBottom>
                        Devices:
                         </Typography>
                         {publicProject.devices && publicProject.devices.map( ( dev ) => (
                        <>
                     <Chip label={dev} variant="outlined" ></Chip> </>
                           ))}


                       </CardContent>

                     </Card>
                </Grid>


          <Grid item xs={12} md={12} lg={12}>

          <Modal
        open={popOpenNO2}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
            <Box sx={style}>
              <Typography id="modal-modal-title" variant="h6" component="h2">
                Pollutant Insights - NO2
              </Typography>
              <Typography id="modal-modal-description" sx={{ mt: 2 }}>
Breathing air with a high concentration of NO2 can irritate airways in the human respiratory system. Such exposures over short periods can aggravate respiratory diseases, particularly asthma,               </Typography>
            </Box>
          </Modal>


          <Modal
        open={popOpenPM}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Typography id="modal-modal-title" variant="h6" component="h2">
            Pollutant Insights - PM 2.5
          </Typography>
          <Typography id="modal-modal-description" sx={{ mt: 2 }}>
               Exposure to fine particles can also affect lung function and worsen medical conditions such as asthma and heart disease.
          </Typography>
        </Box>
      </Modal>


      <Modal
    open={popOpen}
    onClose={handleClose}
    aria-labelledby="modal-modal-title"
    aria-describedby="modal-modal-description"
    >
    <Box sx={style}>
      <Typography id="modal-modal-title" variant="h6" component="h2">
        Pollutant Insights - VOCs
      </Typography>
      <Typography id="modal-modal-description" sx={{ mt: 2 }}>
           Breathing VOCs can irritate the eyes, nose and throat, can cause difficulty breathing and nausea, and can damage the central nervous system and other organs.
      </Typography>
    </Box>
    </Modal>

          <Grid container  alignItems="center"
          justifyContent="center" spacing={2}  direction="row">
              <Grid item xs={3} sx={{ height:1 }}>
                      <Card sx={{ height:1 }}>
                         <CardContent sx={{ height:'100px' }}>
                           <Typography sx={{ fontSize: 24 }}  gutterBottom>
                            {publicProject.deviceProject && publicProject.deviceProject[0].highestNO2} ppb
                           </Typography>
                           <Typography variant="h5" component="div">

                           </Typography>
                           <Typography sx={{ fontSize: 20  }} color="text.secondary">
                           Highest NO2
                           </Typography>

                         </CardContent>

                         <CardActions>
                          <Button size="small" variant="contained" sx={{ bgcolor: '#af8dbf' }} onClick={handleOpenNO2}>What is NO2? </Button>
                         </CardActions>

                       </Card>
                      </Grid>
                      <Grid item xs={3} sx={{ height:1 }}>
                              <Card sx={{ height:1 }}>
                                 <CardContent sx={{ height:'100px' }}>
                                   <Typography sx={{ fontSize: 24 }}  gutterBottom>
                                      {publicProject.deviceProject && publicProject.deviceProject[0].highestPM25} ug/m3
                                   </Typography>
                                   <Typography variant="h5" component="div">

                                   </Typography>
                                   <Typography sx={{ fontSize: 20  }} color="text.secondary">
                                   Highest PM2.5

                                  </Typography>
                                 </CardContent>
                                 <CardActions>
                                  <Button size="small" variant="contained" sx={{ bgcolor: '#af8dbf' }} onClick={handleOpenPM}>What is PM2.5? </Button>
                                 </CardActions>

                               </Card>
                              </Grid>

                              <Grid item xs={3} sx={{ height:1 }}>
                                      <Card sx={{ height:1 }}>
                                         <CardContent sx={{ height:'100px' }}>
                                           <Typography sx={{ fontSize: 24 }}  gutterBottom>
                                           {publicProject.deviceProject && publicProject.deviceProject[0].highestVOC} ppb

                                           </Typography>
                                           <Typography variant="h5" component="div">

                                           </Typography>
                                           <Typography sx={{ fontSize: 16  }} color="text.secondary">
                                           Highest VOCs (Volatile Organic Compounds)
                                           </Typography>

                                         </CardContent>

                                         <CardActions>
                                          <Button size="small" variant="contained" sx={{ bgcolor: '#af8dbf' }} onClick={handleOpen}>What are VOCs? </Button>
                                         </CardActions>

                                       </Card>
                                      </Grid>


                                    <Grid item xs={6} sm={4}>
                                    {publicProject.startDate  &&
                                      <LocalizationProvider dateAdapter={AdapterMoment}>
                                    <DatePicker
                                          label="Date filter"
                                          inputFormat="MM/DD/yyyy"

                                          value={timeValue2 && Moment(timeValue2)}
                                            minDate={Moment(publicProject.startDate)}
                                            maxDate={Moment(publicProject.endDate)}

                                        onChange={onTimeChange2}
                                          renderInput={(params) => <TextField {...params} />}
                                        />

                                      </LocalizationProvider>
                                    }
                                    </Grid>
                                        <Grid item xs={6} sm={4}>
                                        <FormControl>
                                            <FormLabel id="demo-controlled-radio-buttons-group"> Air Quality Filter</FormLabel>
                                            <RadioGroup
                                              aria-labelledby="demo-controlled-radio-buttons-group"
                                              name="controlled-radio-buttons-group"
                                              value={valueThresholdFilter}
                                              onChange={handleChangeThreshold}
                                              row
                                            >
                                                <FormControlLabel labelPlacement="top" value="All"  control={<Radio sx={{color: blue[800],'&.Mui-checked': {color: blue[600],},  }} />} label="All" />
                                                <FormControlLabel labelPlacement="top" value="Good"  control={<Radio sx={{color: green[800],'&.Mui-checked': {color: green[600],},  }} />} label="Good" />
                                                <FormControlLabel labelPlacement="top" value="Moderate"  control={<Radio sx={{color: yellow[800],'&.Mui-checked': {color: yellow[600],},  }} />} label="Moderate" />
                                                <FormControlLabel labelPlacement="top" value="Unhealthy"  control={<Radio sx={{color: red[800],'&.Mui-checked': {color: red[600],},  }} />} label="Unhealthy" />

                                            </RadioGroup>
                                          </FormControl>

                                       </Grid>



            </Grid>






                               <Paper
                                 sx={{
                                   p: 2,
                                   display: 'flex',
                                   flexDirection: 'column',
                                     height: 640
                                 }}
                               >




                               {publicProject.deviceProject &&
                                   <MapContainer  style={{ height: "100%", width: "100%" }} center={[41.54399951992418, -73.03376724985056]} zoom={12.5} scrollWheelZoom={false}>
                                     <TileLayer
                                       attribution="Map data &copy; <a href=&quot;https://www.openstreetmap.org/&quot;>OpenStreetMap</a> contributors, <a href=&quot;https://creativecommons.org/licenses/by-sa/2.0/&quot;>CC-BY-SA</a>, Imagery &copy; <a href=&quot;https://www.mapbox.com/&quot;>Mapbox</a>"
                                       url="https://api.mapbox.com/styles/v1/darrenriley/ckwnd6rg801js15n7fqwqik78/tiles/{z}/{x}/{y}@2x?access_token=pk.eyJ1IjoiZGFycmVucmlsZXkiLCJhIjoiY2t3bmQycnBpMGtuNjMwbzJxa2l0dmlvbyJ9.vbFNzKOFMTIVdZQrx4szgQ"
                                     />
                                     <Legend/>
                                        {publicProject.deviceProject && publicProject.deviceProject.map( ( devData ) => (
                                           <div key={devData}>
                                     {filteredProjectMeasurements && filteredProjectMeasurements.map( ( dev ) => (
                                       <>
                                       {dev.longitude &&
                                       <CircleMarker center={[dev.latitude && dev.latitude,[dev.longitude]]} pathOptions={colorMarker(dev.pollutants)} radius={5}>
                                         <Popup key={dev.date}>

                                                <b>Time:</b> {new Date(dev.date*1000).toLocaleString('en-US')} <br />
                                                <b> DeviceID:</b> {devData.device_ID.device_ID}<br/>
                                                <b> VOC:</b> {dev.pollutants.voc.pi}<br/>
                                                <b> NO2:</b> {dev.pollutants.no2.pi}<br/>
                                                <b> PM2.5:</b> {dev.pollutants.pm25.pi}<br/>
                                                <b> PM10:</b> {dev.pollutants.pm10.pi}<br/>



                                          </Popup>
                                       </CircleMarker>
                                     }
                                     </>
                                     ))}
                                     </div>
                                     ))}

                                     <Marker  key={"12"} position={washingtonElm}  >
                                     <Popup>
                                        Washington Elementary
                                      </Popup>
                                   </Marker>

                                    <Marker key={"13"} position={hopevilleElm} >
                                      <Popup>
                                      Hopeville Elementary
                                      </Popup>
                                   </Marker>

                                   <Marker key={"14"} position={dugganElm} >

                                       <Popup>
                                       Duggan Elementary
                                       </Popup>

                                    </Marker>

                                   </MapContainer>
                                       }




                               </Paper>

                               </Grid>


             </Grid>
           </Container>

        </Box>
      </Box>
    </ThemeProvider>
  );



}


export default PublicProject;
